export const formatCurrency = (numberToRevise: number | string): number => {
  if (
    numberToRevise &&
    (typeof numberToRevise === "number" || typeof numberToRevise === "string")
  )
    return Number(Number(numberToRevise).toFixed(2));
  return 0;
};
